import React, { useState, useEffect } from 'react'

import UserDropdown from './UserDropdown'

import useUserProfile from 'modules/user/useUserProfile'
import { useUserAuthorizations } from 'modules/sso/operations'
import useScript from 'utils/hooks/useScript'
import { useIsMountedRef } from 'utils/hooks/useIsMountedRef'

// With the redesign we don't load Headway, but most probably we will need it
// again in the near future so for now we can just keep a flag to disabled it
const HEADWAY_ENABLED = false

/**
 * The purpose of the `__showHeadway` and `__headwayUnseenCount` variables,
 * is to maintain the same visual look after a hot-update.
 *
 * If we hot-update the app the internal state will be reset,
 * the global variables restores the previous state.
 */

const HEADWAY_ACCOUNT_ID = 'xD4Ojx'

const UserNavbarSection: React.FC = () => {
  const [, setShowHeadway] = useState(window.__showHeadway || false)
  const [, setHeadwayUnseenCount] = useState(window.__headwayUnseenCount || 0)

  const [loaded] = useScript('https://cdn.headwayapp.co/widget.js')
  const { activeAuthorization } = useUserAuthorizations()
  /**
   * We include the active authorization auth token here to make sure we refresh
   * the user information if the active authorization changes (e.g. switch from
   * SSO auth to personal auth or the other way around). This can happen when
   * switching teams from the teams dropdown.
   */
  const { data } = useUserProfile(true, {
    variables: { id: activeAuthorization?.fragment.authToken },
  })

  const isMountedRef = useIsMountedRef()

  useEffect(() => {
    if (!HEADWAY_ENABLED) return

    /**
     * Check this widget configuration here
     * https://docs.headwayapp.co/widget#options
     */
    window.Headway?.init({
      account: HEADWAY_ACCOUNT_ID,
      selector: '#headway',
      trigger: '#headway',
      callbacks: {
        onWidgetReady: (widget: any) => {
          if (!isMountedRef.current) return

          const unseenCount = widget.getUnseenCount()
          setHeadwayUnseenCount(unseenCount)
          window.__headwayUnseenCount = unseenCount

          if (unseenCount > 0) {
            setShowHeadway(true)
            window.__showHeadway = true
          }
        },
        onShowWidget: () => {
          if (!isMountedRef.current) return

          setHeadwayUnseenCount(0)
          window.__headwayUnseenCount = 0
        },
      },
    })
  }, [loaded, isMountedRef])

  return <UserDropdown user={data?.me} />
}

export default UserNavbarSection
